import React, { useState } from 'react';

interface PhotoLightboxProps {
  photos: string[];
  initialIndex: number;
  onClose: () => void;
}

export const PhotoLightbox: React.FC<PhotoLightboxProps> = ({
  photos,
  initialIndex,
  onClose,
}) => {
  const [index, setIndex] = useState(initialIndex);

  const goPrev = () => setIndex(i => Math.max(0, i - 1));
  const goNext = () => setIndex(i => Math.min(photos.length - 1, i + 1));

  return (
    <div className="pc-lightbox" onClick={onClose}>
      <button className="pc-lightbox-close" onClick={onClose}>✕</button>

      <img
        className="pc-lightbox-img"
        src={photos[index]}
        alt={`Photo ${index + 1}`}
        onClick={e => e.stopPropagation()}
      />

      <div className="pc-lightbox-nav" onClick={e => e.stopPropagation()}>
        <button className="pc-lightbox-btn" onClick={goPrev} disabled={index === 0}>
          ← Prev
        </button>
        <span className="pc-lightbox-counter">{index + 1} / {photos.length}</span>
        <button className="pc-lightbox-btn" onClick={goNext} disabled={index === photos.length - 1}>
          Next →
        </button>
      </div>
    </div>
  );
};
